export default {"src":"/polygon/_next/static/media/meshswap.10a1832b.svg","height":386,"width":354};